module.exports = __webpack_public_path__ + "img/banner.b7bbc693.png";